"use client";

import { useState } from "react";
import Link from "next/link";

export default function ResetPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch("/api/reset-password/request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        const data = await res.json();
        setError(data.error || "Une erreur est survenue");
        return;
      }

      setSubmitted(true);
    } catch {
      setError("Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="bg-surface rounded-lg shadow-md border border-border p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold text-text-primary mb-6 text-center">
          Reinitialiser votre mot de passe
        </h1>

        {submitted ? (
          <div>
            <p className="text-sm text-text-secondary text-center mb-6">
              Si un compte existe avec cet email, un lien de reinitialisation a
              ete envoye.
            </p>
            <Link
              href="/login"
              className="block text-center text-sm text-accent hover:text-accent-hover"
            >
              Retour a la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-text-secondary mb-1"
              >
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full border border-border rounded-md px-3 py-2 text-sm bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-accent"
                placeholder="votre@email.com"
              />
            </div>

            {error && (
              <p className="text-sm text-danger-text">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-accent text-white py-2 px-4 rounded-md hover:bg-accent-hover disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
            >
              {loading ? "Envoi en cours..." : "Envoyer le lien"}
            </button>

            <Link
              href="/login"
              className="block text-center text-sm text-accent hover:text-accent-hover"
            >
              Retour a la connexion
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
